module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "box--camera--container"
    }
  }, [_c('div', {
    attrs: {
      "id": "box-camera"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "camera--canvas"
    }
  }), _vm._v(" "), _c('video', {
    attrs: {
      "id": "camera--video",
      "autoplay": "",
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": "",
      "alt": "",
      "id": "camera--output"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "camera--trigger"
    }
  }, [_vm._v("Tirar foto")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "box--loading"
    }
  }, [_c('svg', {
    staticStyle: {
      "margin": "auto",
      "background": "transparent",
      "display": "block"
    },
    attrs: {
      "id": "loading",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "80px",
      "height": "80px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "fill": "none",
      "stroke": "#cccccc",
      "stroke-width": "10",
      "r": "35",
      "stroke-dasharray": "164.93361431346415 56.97787143782138",
      "transform": "rotate(304.35 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "dur": "1s",
      "values": "0 50 50;360 50 50",
      "keyTimes": "0;1"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02266a8c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/camera.vue
// module id = LcDH
// module chunks = 36